// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"51b122db","363":"5cab76d3","406":"cf0a64ed","551":"9256f25f","570":"6c547f4b","637":"21fa4fa6","706":"020302a4","832":"d5d0f08c","867":"732c240f","960":"8bcbda57"}[chunkId] + ".css";
};